import { Card, Stack, Typography } from '@healthinal/ui';
import { useGetMedicationChangeHistory } from '../../../../../api/generated/patient-controller/patient-controller.ts';
import { formatDateTime } from '../../../../../utils/date.ts';
import { MedicationChangeComparison } from '../../../../components/therapy/MedicationChangeComparison.tsx';

export function MedicationChangeHistory({ patientId }: { patientId: string }) {
  const { data: medicationChanges } = useGetMedicationChangeHistory(patientId);

  return (
    <Stack gap={2}>
      <Typography level={'h3'}>Change History</Typography>
      {medicationChanges?.map((medicationChange) => (
        <Card key={medicationChange.date + medicationChange.therapyPhase}>
          <Stack direction={'row'}>
            <Stack flex={1}>
              <Typography level={'body-sm'}>
                {medicationChange.date && formatDateTime(medicationChange.date)}
              </Typography>
              <Typography level={'title-lg'}>Medikation geändert</Typography>
              <Typography>
                {medicationChange.user?.firstName} {medicationChange.user?.lastName}
              </Typography>
            </Stack>
            <Stack flex={2}>
              <MedicationChangeComparison medicationChange={medicationChange} />
            </Stack>
          </Stack>
        </Card>
      ))}
    </Stack>
  );
}
